import React from "react";
import { NavLink } from "react-router-dom";

/*
 * Website Analytics switcher (specs/WEB_ACTIVITY_DASHBOARD_2026-09-28.md §2.1).
 * Seven views under one page: the first five render in views/web-activity,
 * Funnels and Heat keep their own views + routes. Rendered by the Website Analytics
 * shell and by the Funnels / Heat pages so the strip never disappears.
 * (Replaces the §222 four-tab strip; the legacy tab views stay reachable at
 * /Activity/legacy/* until the numbers are reconciled.)
 */
const VIEWS = [["/Activity", "Overview", p => p === "/Activity" || p === "/SiteActivity" || /^\/Activity\/overview/i.test(p)], ["/Activity/acquisition", "Acquisition", p => /^\/Activity\/acquisition/i.test(p)], ["/Activity/pages", "Pages", p => /^\/Activity\/pages/i.test(p)], ["/Activity/products", "Products", p => /^\/Activity\/products/i.test(p)], ["/Activity/places", "Places", p => /^\/Activity\/places/i.test(p)], ["/Activity/Funnels/this_month", "Funnels", p => /^\/Activity\/Funnels/i.test(p)], ["/Activity/Heat/this_month", "Heat", p => /^\/Activity\/Heat/i.test(p)]];
export default function WebActivitySwitcher({
  range
}) {
  return /*#__PURE__*/React.createElement("nav", {
    className: "wa-switch",
    "aria-label": "Website Analytics views"
  }, VIEWS.map(([to, label, test]) => /*#__PURE__*/React.createElement(NavLink, {
    key: label,
    to: range && /this_month$/.test(to) ? to.replace(/this_month$/, range) : to,
    className: "wa-tab",
    activeClassName: "on",
    isActive: (match, loc) => test(loc.pathname)
  }, label)));
}